/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import '../index.scss';

import searchIcon from '../../../assets/images/busca-preto.svg';

const NewBotSearchTemplate = (props) => {
  const { originalTemplateBots } = props;
  const [searchTerm, setSearchTerm] = useState('');

  /**
   * Called when the searchTerm change, for update the filtered list of elements
   */
  useEffect(() => {
    updateCurrentList();
  }, [searchTerm, originalTemplateBots]);

  const onSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  /**
   * Update the current list used for displaying the cards
   */
  const updateCurrentList = () => {
    const { setCurrentTemplateList } = props;
    if (searchTerm === '') {
      setCurrentTemplateList(originalTemplateBots);
    } else {
      formatCustomTemplatesList();
    }
  };

  /**
   * Format the current list for a custom filtered by the search term
   */
  const formatCustomTemplatesList = () => {
    const { currentTemplateList, setCurrentTemplateList } = props;
    const filterList = _.filter(currentTemplateList, (template) => {
      const { title, categories, shortDescription } = template;
      const hasTitle =
        title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
      const hasCategory = categories.find(
        (category) =>
          category.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      );
      const hasShortDescription =
        shortDescription.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;

      if (hasTitle || hasCategory || hasShortDescription) {
        return template;
      }
    });

    setCurrentTemplateList(filterList);
  };

  return (
    <div className="new-bot-actions-search-template">
      <img src={searchIcon} alt="Lupa" />
      <input
        className="input-test"
        type="text"
        placeholder="Buscar bot"
        value={searchTerm}
        onChange={onSearchInputChange}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bots: state.bots,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBotSearchTemplate);
